import React from 'react';
import Skeleton from "@material-ui/lab/Skeleton";
import {Paper } from '@material-ui/core';
import { useSubPanelStyles } from '../styles/muiStyles';




const SkeletonHive = () => {
const classes = useSubPanelStyles();
  return (
    <div>
     <Paper variant="outlined" style={{marginTop:20 , paddingBottom:30}} className={classes.listPaper}>
     <Skeleton variant="rect" width="60%" height={230} style={{ marginTop: 10 , marginBottom: 20 ,  width:'auto', marginLeft: 10 , marginRight: 10 , borderRadius:15,  }}  />
     <Skeleton width="90%" height={30}  variant="rect" style={{ marginBottom: 25 , width:'auto', borderRadius:13 }}  />
     <Skeleton width="60%" style={{  marginTop: 10 , width:'auto', marginLeft: 90 , marginRight: 90 ,  width:'auto' , borderRadius:13,}}  />

                  
      <div style={{margin:'auto' }} >

      </div>
      </Paper>
        
    </div>
  );
};


export default SkeletonHive;